import { v4 as uuidv4 } from 'uuid'
export const getGeo = async (axios, address) => {
  // Address Format: "<address1> <?address2>, <city>, <state> <zip>"
  const searchString = [
    [address.address1, address.address2].filter((part) => !!part).join(' '),
    address.city,
    [address.state, address.zip].filter((part) => !!part).join(' '),
  ]
    .filter((part) => !!part)
    .join(', ')

  const response = await axios.post(`/GEO_CODING/geocode`, {
    search_string: searchString,
    response_format: 'geojson',
  })
  return response?.data
}

export const addAddress = async (axios, address) => {
  const geo = await getGeo(axios, address)
  const result = await axios.post(`/PROFILE_URL/address`, {
    ...address,
    friendly_name: '',
    address_uuid: '',
    meta: geo,
  })

  return result?.data
}

export const updateAddress = async (axios, address) => {
  const geo = await getGeo(axios, address)
  const payload = {
    ...address,
    meta: geo,
  }
  const result = await axios.patch(`/PROFILE_URL/address`, payload)
  return result?.data
}

export const deleteAddress = (axios, address) => {
  return axios.$delete(`/PROFILE_URL/address/${address.address_uuid}`)
}

export const smartyAddressVerification = async (axios, address) => {
  const data = await axios.post('/GEO_CODING/geocode/smarty', [
    {
      ...address,
      input_id: uuidv4(),
      zipcode: address.zip,
    },
  ])
  return data
}
